import rootReducer from "./rootReducer";
import { configureStore } from "@reduxjs/toolkit";
import productSaga from "./product/productSaga";
import createSagaMiddleware from "redux-saga";

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// Configure the Redux store with the root reducer and saga middleware
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
});

// Run the root saga
sagaMiddleware.run(productSaga);

export default store;
